import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-circular-progressbar/dist/styles.css";

import Practice from "../../components/SPanel/Practice";
import PracticeStatistics from "../../components/SPanel/PracticeStatistics";

function SPTest() {
   return (
      <main className="main">
         <section className="page-wrapper">
            <Practice />
            <PracticeStatistics />
         </section>
      </main>
   );
}

export default SPTest;
